// purehealthnexus\src\components\AiDashboard\AiMyNutritionStatus\AiUser\LocalDateIso.js
export class LocalDateIso {
  static padTwoDigits(value) {
    return String(value).padStart(2, '0');
  }

  static today() {
    return LocalDateIso.fromDate(new Date());
  }

  static fromDate(date) {
    if (!(date instanceof Date) || Number.isNaN(date.getTime())) {
      return null;
    }
    const year = date.getFullYear();
    const month = LocalDateIso.padTwoDigits(date.getMonth() + 1);
    const day = LocalDateIso.padTwoDigits(date.getDate());
    return `${year}-${month}-${day}`;
  }

  static parse(dateIso) {
    const normalized = String(dateIso || '').trim();
    const match = normalized.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!match) return null;

    const year = Number(match[1]);
    const monthIndex = Number(match[2]) - 1;
    const day = Number(match[3]);

    const noonLocal = new Date(year, monthIndex, day, 12, 0, 0, 0);
    if (Number.isNaN(noonLocal.getTime())) return null;
    return noonLocal;
  }

  static addDays(dateIso, deltaDays) {
    const base = LocalDateIso.parse(dateIso);
    if (!base) return null;
    const shifted = new Date(
      base.getFullYear(),
      base.getMonth(),
      base.getDate() + Number(deltaDays || 0),
      12,
      0,
      0,
      0,
    );
    return LocalDateIso.fromDate(shifted);
  }

  static startOfDay(dateIso) {
    const base = LocalDateIso.parse(dateIso);
    if (!base) return null;
    return new Date(base.getFullYear(), base.getMonth(), base.getDate(), 0, 0, 0, 0);
  }

  static endOfDayExclusive(dateIso) {
    const base = LocalDateIso.parse(dateIso);
    if (!base) return null;
    return new Date(base.getFullYear(), base.getMonth(), base.getDate() + 1, 0, 0, 0, 0);
  }

  static millisecondsUntilNextLocalMidnight() {
    const now = new Date();
    const next = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 2, 0);
    const delta = next.getTime() - now.getTime();
    return Math.max(1000, delta);
  }

  static createBlankDailyIntakeDocument(dateIso) {
    const normalized = String(dateIso || '').trim();
    return {
      dateIso: normalized,
      placeholder: true,
      consumed: [],
      consolidated_nutrients: {},
      nutrients: {},
      totals: {},
      updatedAt: null,
      createdAt: null,
    };
  }
}

export class LocalDateRolloverScheduler {
  constructor(onDateIsoChanged) {
    this.onDateIsoChanged = typeof onDateIsoChanged === 'function' ? onDateIsoChanged : null;
    this.timeoutHandle = null;
    this.running = false;
  }

  start() {
    if (this.running) return;
    this.running = true;
    this.scheduleNextTick();
  }

  stop() {
    this.running = false;
    if (this.timeoutHandle) {
      clearTimeout(this.timeoutHandle);
      this.timeoutHandle = null;
    }
  }

  scheduleNextTick() {
    if (!this.running) return;

    const delay = LocalDateIso.millisecondsUntilNextLocalMidnight();
    this.timeoutHandle = setTimeout(() => {
      if (!this.running) return;
      const nextDateIso = LocalDateIso.today();
      if (this.onDateIsoChanged) {
        this.onDateIsoChanged(nextDateIso);
      }
      this.scheduleNextTick();
    }, delay);
  }
}
